import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import ServiceProviderClient from './ServiceProviderClient';
import { NotFound } from '@/components/service-provider/NotFound';
import { UserProfile } from '@/types/user';
import { LoadingSpinner } from '@/components/service-provider/LoadingSpinner';

export default function ServiceProviderPage() {
  const [provider, setProvider] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const loadProvider = async () => {
      try {
        if (!id) {
          setError('ID do prestador não fornecido');
          return;
        }

        const docRef = doc(db, 'users', id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setProvider({
            id: docSnap.id,
            ...docSnap.data()
          } as UserProfile);
        } else {
          setError('Prestador não encontrado');
          setProvider(null);
        }
      } catch (error) {
        console.error('Error loading provider:', error);
        setError('Erro ao carregar informações do prestador');
        setProvider(null);
      } finally {
        setLoading(false);
      }
    };

    loadProvider();
  }, [id]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error || !provider) {
    return <NotFound error={error} />;
  }

  return <ServiceProviderClient provider={provider} navigate={navigate} />;
}